package twist.mena.sports.admin.screens

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import twist.mena.sports.admin.api.AdminApiClient
import twist.mena.sports.admin.state.*
import twist.mena.sports.admin.theme.*

@Composable
fun VerifyScreen(apiClient: AdminApiClient) {
    val colors = AppTheme.colors
    var state by remember { mutableStateOf<UiState<String>>(UiState.Loading) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(Unit) {
        val magicToken = NavState.getMagicToken()
        if (magicToken == null) {
            state = UiState.Error("Invalid link")
            return@LaunchedEffect
        }

        scope.launch {
            try {
                val response = apiClient.verifyToken(magicToken)
                AuthState.setToken(response.token)
                // Clear magic_token from URL to prevent re-use on refresh
                kotlinx.browser.window.history.replaceState(null, "", kotlinx.browser.window.location.pathname)
                NavState.navigate(Screen.TEAMS)
            } catch (e: Exception) {
                state = UiState.Error("Link is invalid, expired, or already used")
            }
        }
    }

    Div({
        style {
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            minHeight(100.vh)
            backgroundColor(Color(colors.background))
            themeTransition()
        }
    }) {
        Div({
            style {
                cardStyle(colors)
                textAlign("center")
            }
        }) {
            when (val s = state) {
                is UiState.Loading -> {
                    H3({ style { color(Color(colors.text)) } }) { Text("Verifying...") }
                    P({ style { color(Color(colors.textMuted)) } }) { Text("Please wait") }
                }
                is UiState.Error -> {
                    H3({ style { color(Color(colors.danger)) } }) { Text("Verification Failed") }
                    P({ style { color(Color(colors.textMuted)); marginTop(Spacing.sm) } }) { Text(s.message) }
                    Button({
                        onClick { NavState.navigate(Screen.LOGIN) }
                        style {
                            marginTop(Spacing.xl)
                            primaryButtonStyle(colors)
                        }
                    }) { Text("Back to Login") }
                }
                is UiState.Success -> {
                    Text("Verified successfully")
                }
            }
        }
    }
}
